import React, { Component } from 'react';
import PropTypes from 'prop-types';
import EventBus from '../EventBus';
import SurveyPopup from './SurveyPopup';
import Classes from '../Classes';

class SurveyPopupWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      canShowSurvey: false
    };
    this.closeSurveyPopup = this.closeSurveyPopup.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside, true);
    EventBus.on('SurveyPopup', () => {
      this.setState({ canShowSurvey: true });
    });
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside, true);
    EventBus.remove('SurveyPopup');
  }

  handleClickOutside(event) {
    if (event.target.className === Classes.surveyPopup.surveyFeedbackContainer) {
      this.closeSurveyPopup();
    }
  }

  closeSurveyPopup() {
    this.setState({ canShowSurvey: false });
  }

  render() {
    return (
      <div>
        {
          this.state.canShowSurvey
          && (
          <SurveyPopup
            uri={this.props.surveyUri}
            onClose={this.closeSurveyPopup}
            spinnerMessage={this.props.spinnerMessage}
          />
          )
        }
      </div>
    );
  }
}

SurveyPopupWrapper.propTypes = {
  surveyUri: PropTypes.string.isRequired,
  spinnerMessage: PropTypes.string.isRequired
};
export default SurveyPopupWrapper;
